import { action, makeObservable, observable } from "mobx"
import {
  FestExpertFinalistsListGetResponse,
  FestExpertFinalistsListItemModel
} from "../../models/FestExpertModels/FinalistsList.model"
import { ApiRequestStore } from "../common/apiRequest.store"

class FestExpertFinalistsListStore extends ApiRequestStore {
  @observable finalists?: FestExpertFinalistsListItemModel[];
  @observable count?: number;
  @observable totalCount?: number;
  @observable currentOffset?: number;

  @action
  setFinalistsListData(data: FestExpertFinalistsListGetResponse): void {
    if (this.finalists && data.items) {
      this.finalists = [...this.finalists, ...data.items]
    } else {
      this.finalists = data.items
    }
    this.count = data.count
    this.totalCount = data.totalCount
  }

  @action
  setOffset = (newOffset: number): void => {
    this.currentOffset = newOffset
  }

  @action
  clearData = (): void => {
    this.finalists = undefined
    this.count = undefined
    this.totalCount = undefined
    this.currentOffset = undefined
  }

  @action
  getFinalists = (): FestExpertFinalistsListItemModel[] => this.finalists ?? []

  @action
  getData = () => ({
      finalists: this.finalists,
      count: this.count,
      totalCount: this.totalCount,
      currentOffset: this.currentOffset,
      isLoading: this.isLoading
    })
}

export const festExpertFinalistsListStore: FestExpertFinalistsListStore = new FestExpertFinalistsListStore()
